import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';

import { CustomerContext } from 'context/customer';

import SavedAddresses from '../SavedAddresses/SavedAddresses';
import LocateMeDropdown from '../LocateMeDropdown/LocateMeDropdown';

import styles from './DefaultDropdown.module.scss';

function DefaultDropdown({ cssModifier, hideDefaultDropdown, mparticleSource, onSelectAddress }) {
  const { user } = useContext(CustomerContext);
  const savedAddresses = user?.delivery?.addresses || [];
  // On the homepage, pull the location out of the document flow
  // On search, keep it relative
  const dropdownClass = classNames(styles.defaultDropdown, cssModifier);

  return (
    <div className={styles.defaultDropdownWrapper} data-testid="DefaultLocationSearchDropdown">
      <div className={dropdownClass}>
        <LocateMeDropdown
          hideDefaultDropdown={hideDefaultDropdown}
          mparticleSource={mparticleSource}
          onSelectAddress={onSelectAddress}
        />
        {savedAddresses.length > 0 && (
          <SavedAddresses
            hideDefaultDropdown={hideDefaultDropdown}
            mparticleSource={mparticleSource}
            onSelectAddress={onSelectAddress}
            savedAddresses={savedAddresses}
          />
        )}
      </div>
    </div>
  );
}

export default onClickOutside(DefaultDropdown);

DefaultDropdown.propTypes = {
  cssModifier: PropTypes.string,
  hideDefaultDropdown: PropTypes.func.isRequired,
  mparticleSource: PropTypes.string.isRequired,
  onSelectAddress: PropTypes.func.isRequired,
};

DefaultDropdown.defaultProps = {
  cssModifier: '',
};
